"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAccessorialRef = exports.LoadAccessorial = void 0;
var mobx_keystone_1 = require("mobx-keystone");
var AccessorialLeg_1 = require("./AccessorialLeg");
var Manifest_1 = require("./Manifest");
var LoadAccessorial = /** @class */ (function (_super) {
    __extends(LoadAccessorial, _super);
    function LoadAccessorial() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getRefId = function () { return "".concat(_this.id); };
        return _this;
    }
    LoadAccessorial_1 = LoadAccessorial;
    LoadAccessorial.prototype.update = function (data) {
        var _this = this;
        var rootStore = (0, mobx_keystone_1.getRootStore)(this);
        if (!rootStore) {
            return;
        }
        var result = LoadAccessorial_1._formatData(rootStore, data);
        if (result) {
            var accessorial = result.accessorial, legs = result.legs;
            Object.assign(this, accessorial);
            if (legs && legs.length > 0) {
                this.legs.clear();
                legs.forEach(function (accessorialLeg) {
                    var newAccLeg = AccessorialLeg_1.LoadAccessorialLeg.create(rootStore, accessorialLeg);
                    if (newAccLeg) {
                        _this.legs.add(newAccLeg);
                    }
                });
            }
        }
    };
    var LoadAccessorial_1;
    LoadAccessorial._formatData = function (rootStore, data) {
        var loadAccessorial = __assign({}, data);
        try {
            loadAccessorial.manifest = (0, Manifest_1.manifestRef)("".concat(data.manifest));
            delete loadAccessorial.legs;
            return {
                accessorial: loadAccessorial,
                legs: data.legs,
            };
        }
        catch (error) {
            console.warn('[WARN] error', error);
            return null;
        }
    };
    LoadAccessorial.create = function (rootStore, data) {
        var result = LoadAccessorial_1._formatData(rootStore, data);
        if (result) {
            var accessorial = result.accessorial, legs = result.legs;
            var newLoadAccessorial_1 = new LoadAccessorial_1(accessorial);
            if (legs && legs.length > 0) {
                legs.forEach(function (accessorialLeg) {
                    var newAccLeg = AccessorialLeg_1.LoadAccessorialLeg.create(rootStore, accessorialLeg);
                    if (newAccLeg) {
                        newLoadAccessorial_1.legs.add(newAccLeg);
                    }
                });
            }
            return newLoadAccessorial_1;
        }
        else {
            return null;
        }
    };
    __decorate([
        mobx_keystone_1.modelAction
    ], LoadAccessorial.prototype, "update", null);
    LoadAccessorial = LoadAccessorial_1 = __decorate([
        (0, mobx_keystone_1.model)('doc-mate/LoadAccessorial')
    ], LoadAccessorial);
    return LoadAccessorial;
}((0, mobx_keystone_1.Model)({
    id: (0, mobx_keystone_1.prop)(),
    manifest: (0, mobx_keystone_1.prop)(),
    quantity: (0, mobx_keystone_1.prop)(),
    description: (0, mobx_keystone_1.prop)(),
    notes: (0, mobx_keystone_1.prop)(),
    revenue: (0, mobx_keystone_1.prop)(),
    legs: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.arraySet)(); }),
})));
exports.LoadAccessorial = LoadAccessorial;
exports.loadAccessorialRef = (0, mobx_keystone_1.rootRef)('doc-mate/LoadAccessorialRef', {
    getId: function (target) {
        if (target instanceof LoadAccessorial) {
            return "".concat(target.id);
        }
    },
});
